import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { Numeric } from '@blade/ui-kit'
import { RankCard } from '@root/entities/leaderboard/ui/desktop'
import { profileAtom, tradingProfitUsdAtom } from '@root/entities/profile'
import { TradingLeaderboardTable } from '@root/features/leaderboard/ui/desktop'
import { useAppRoutes } from '@root/features/routing'
import { useTranslation } from '@root/shared/localization'

import { Board } from '../../common'
import { BoardTitle } from '../../common/board-title'

type ReferralsBoardProps = {}

export const TradingLeaderboardBoard: React.FC<ReferralsBoardProps> = () => {
  const { t } = useTranslation()
  const { navigateToProfileIndex } = useAppRoutes()

  const [profile] = useAtom(profileAtom)
  const [tradingProfit] = useAtom(tradingProfitUsdAtom)
  const rank = profile?.tradeRank

  return (
    <Board>
      <Header>
        <BoardTitle
          onBack={navigateToProfileIndex}
          title={t('profile.statistics.trading_leaderboard')}
        />

        <End>
          <RankCard
            rank={rank}
            color="up"
            profit={
              <Numeric
                value={tradingProfit ?? 0}
                preset="currency-amount-short"
                currency="$"
              />
            }
          />
        </End>
      </Header>
      <TradingLeaderboardTable />
    </Board>
  )
}

const Header = styled.div`
  height: 42px;
  display: grid;
  align-items: center;
  padding-inline: 8px 16px;
  grid-template-columns: auto 1fr;
  gap: 16px;
`

const End = styled.div`
  justify-self: end;
`
